import {NgbTabChangeEvent,NgbTabset,NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { Component,NgZone, OnInit,ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef,HostListener } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import {commonService} from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { jobService } from '../../service/job.service';
import { HttpErrorResponse } from '@angular/common/http';
import { userService } from '../../service/user.service';
import {Globals } from '../../globals';


import { GooglePlaceDirective } from "ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
import { ComponentRestrictions } from "ngx-google-places-autocomplete/objects/options/componentRestrictions";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { AutoCompleteSearchService } from 'ng4-geoautocomplete/auto-complete.service';
import { GlobalRef } from 'ng4-geoautocomplete/windowRef.service';
import { AgmCoreModule, MapsAPILoader,GoogleMapsAPIWrapper } from '@agm/core';
import { contentService } from '../../service/content.service';
import { ViewEncapsulation } from '@angular/core';


export interface Settings {
  geoPredictionServerUrl?: string;
  geoLatLangServiceUrl?: string;
  geoLocDetailServerUrl?: string;
  geoCountryRestriction?: any;
  geoTypes?: any;
  geoLocation?: any;
  geoRadius?: number;
  serverResponseListHierarchy?: any;
  serverResponseatLangHierarchy?: any;
  serverResponseDetailHierarchy?: any;
  resOnSearchButtonClickOnly?: boolean;
  useGoogleGeoApi?: boolean;
  inputPlaceholderText?: string;
  inputString?: string;
  showSearchButton?: boolean;
  showRecentSearch?: boolean;
  showCurrentLocation?: boolean;
  recentStorageName?: string;
  noOfRecentSearchSave?: number;
  currentLocIconUrl?: string;
  searchIconUrl?: string;
  locationIconUrl?: string;   
}

@Component({
  selector: 'app-vjob',
  templateUrl: './vjob.component.html',
  //directives:[CeiboShare],
  styleUrls: ['./vjob.component.css'],
  
encapsulation: ViewEncapsulation.None,
  providers: [NgbTabsetConfig,NgbTabset,sessionService,jobService,userService,contentService],
  host: {
    '(document:click)': 'closeAutocomplete($event)',
   }
})
export class VjobComponent implements OnInit {
  @ViewChild('content') gElement: any;
  @Input() userSettings: Settings;
  @Output()
  public repoUrll = 'https://github.com/Epotignano/ng2-social-share';
  public imageUrll = 'https://avatars2.githubusercontent.com/u/10674541?v=3&s=200';
componentCallback: EventEmitter<any> = new EventEmitter<any>();
Jobs="Jobs";

technical:Array<any>=[];
nontechnical:Array<any>=[];
privateJob:Array<any>=[];
listValue:Array<any>=[];
privateAll:Array<any>=[];
nontechnicalAll:Array<any>=[];
technicalAll:Array<any>=[];
announcementlist:Array<any>=[];
announcementSort:Array<any>=[];
viewMore=true;

public locationInput: string = '';
public lat: string = '';
public lng: string = '';
public latitude: number;
public longitude: number;
public zoom: number;
public searchControl: FormControl;
@ViewChild("search")
public searchElementRef: ElementRef;
public gettingCurrentLocationFlag: boolean = false;
public dropdownOpen: boolean = false;
public recentDropdownOpen: boolean  = false;
public queryItems: any = [];
public isSettingsError: boolean = false;
public settingsErrorMsg: string = '';
public settings: Settings = {};
private moduleinit: boolean = false;
private selectedDataIndex: number = -1;
private recentSearchData: any = [];
private userSelectedOption: any = '';
private defaultSettings: Settings = {
  geoPredictionServerUrl: '',
  geoLatLangServiceUrl: '',
  geoLocDetailServerUrl: '',
  geoCountryRestriction: [],
  geoTypes: [],
  geoLocation: [],
  geoRadius: 0,
  serverResponseListHierarchy: [],
  serverResponseatLangHierarchy: [],
  serverResponseDetailHierarchy: [],
  resOnSearchButtonClickOnly: false,
  useGoogleGeoApi: true,
  inputPlaceholderText: 'Enter Area Name',
  inputString: '',
  showSearchButton: true,
  showRecentSearch: true,
  showCurrentLocation: true,
  recentStorageName: 'recentSearches',
  noOfRecentSearchSave: 5,
  currentLocIconUrl: '',
  searchIconUrl: '',
  locationIconUrl: ''
};

searchFrom: FormGroup;
user:any;
  isError=false;
  pgshowgallery=false;
  msg:any;
  hostelruleslist:any;
  isSuccess=false;
  totalrow:number;
  searchtxt:string;
  notfound=false;
  filterdetail=[];
  //sortedData;
  pageSize = 10;
  currentPage = 0;
  totalSize = 0;
  start=0;
  end=5;
  closeResult: string;
  limit=20;

  contentlist=[];
  isPostLoad=true;
  isJobLoad=true;
  isRemaningForum=true;
  noMoreResults=false;
  jobtypeval:'';
  citybox:any;
  pageoffset=0;

  topicbox:any;
  topiclist:any;
  tagposttopic:any;
  topic:any;
  pathsocialshare:any;
  Jobtypebox:any;
  datanotfound=false;
  boolenBox:String='';
  privateBox:boolean=true;
  techBox:boolean=true;
  nontechBox:boolean=true;
  obj:any;
   //define the toogle property
   private toggle : boolean = false;
 
  JOBS={'title':'Student Portal – Sarkari Result and Govt Jobs Notifications','desciprtion':'Find all latest govt jobs notifications 2019, sarkari result notification, PSU through GATE, government jobs for engineers, engineering recruitment, jobs in public sect.','keywords':'govt jobs notifications, sarkari result notification, PSU through GATE, government jobs for engineers, engineering recruitment'};
  readonly filepathUrl  =  this.global.announceUrl; // path for linked document

/***** */
@Input() urlfb = location.href;
@Input() urlg = location.href;


 url = 'http://jasonwatmore.com';
 text = 'ghgfjfjghj gnfgmnghmghmgh';
 imageUrl = 'http://jasonwatmore.com/_content/images/jason.jpg';
/****** */
constructor(config: NgbTabsetConfig,public tabset: NgbTabset,public router: Router,private frmBuilder: FormBuilder,private commonService:commonService,private _session:sessionService,private job:jobService,private route: ActivatedRoute,private _user:userService,private _autoCompleteSearchService: AutoCompleteSearchService,
  private ngZone: NgZone,private global: Globals,private _elmRef: ElementRef,@Inject(PLATFORM_ID) private platformId: Object,private _content:contentService) {

    this.obj={};
    this.obj.announcelist=[];

        /***** face book share code*/
        // initialise facebook sdk after it loads if required
        if (!window['fbAsyncInit']) {
          window['fbAsyncInit'] = function () {
              window['FB'].init({
                  appId: '753219958385417',
                  autoLogAppEvents: true,
                  xfbml: true,
                  version: 'v3.0'
              });
          };
      }

      // // load facebook sdk if required
      const urlfb = 'https://connect.facebook.net/en_US/sdk.js';
      if (!document.querySelector(`script[src='${urlfb}']`)) {
          let script = document.createElement('script');
          script.src = urlfb;
          document.body.appendChild(script);
      }
        /****** face book share code*/
        /*****google plus share code*** */
        // load google plus sdk if required
        const url = 'https://apis.google.com/js/platform.js';
        if (!document.querySelector(`script[src='${url}']`)) {
            let script = document.createElement('script');
            script.src = url;
            document.body.appendChild(script);
        }
        /*****google plus share code*** */
        this.pathsocialshare=this.global.websiteUrl+'jobdetail?searchparam=';

        this.Jobtypebox='';
 }



 ngAfterViewInit(): void {
  // render facebook button
  window['FB'] && window['FB'].XFBML.parse();
  // render google plus button
  window['gapi'] && window['gapi'].plusone.go();
  }

  ngOnInit() {  
    let formdata:any={};
    formdata.offset= this.contentlist.length?this.contentlist.length:0;
    formdata.limit=this.limit;
    formdata.distancestart='0';
    formdata.distance='15';
    this.getjoblist(formdata);
    this.getposttopic();
    if (!this.moduleinit) {
      this.moduleInit();
      }
      this.getannoucelist(this.obj);    
  }


  viewmoretopic(){ // need to check data
    
      this.obj.viewmore=false; //this.isPostLoad = true;
      let objdata={};    
      objdata['offset']= this.obj.announcelist.length?this.obj.announcelist.length:0; 
      objdata['limit'] =5; 
   
      this.getannoucelist(objdata);    
   }

  getannoucelist(obj){   
    this.job.getannoucelist({type:'frt'}).subscribe((data : any)=>{
            if(data.error==0){
                this.announcementlist = data.results.rows; 
               // console.log('list',this.announcementlist);

              Array.prototype.push.apply(this.obj.announcelist,this.announcementlist);
            //  console.log('grtrtert',this.obj.announcelist);
              if(data.results.count > this.obj.announcelist.length){
                  this.obj.viewmore=true;
              }else{
                this.obj.viewmore=false;
              }     

              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }        
            }else{  
            //  console.log('No DAta');            
               this.msg = data.message;
               this.isError = true;              
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });          
}


  hidedropdwn(){
    this.dropdownOpen = false;
  }
  topicfunc(data){
    return  data.split(',');
    }
  getposttopic(){
    var category='Job';
    this._content.getposttopic(category).subscribe((data : any)=>{     
      if(data.error==0){     
        //this.getdownloadContent();
       var objArray = {};
       var mainArray = [];
       var newArray  = {}
       
       for(var row of data.results){
          objArray['display']= row.title;
          objArray['value']= row.id;
          newArray[row.id]=row.title;
            mainArray.push(objArray);
            objArray = {};
        }
       this.topicbox = mainArray;
       //console.log(this.topicbox);
       //console.log(newArray);
       this.topiclist = newArray;
       
       //this.topic=this.getpermissionArray(this.tagposttopic,this.topicbox);
 
      
    }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    });  

  }

  searchfilter(form){
    //console.log('frmVal',form.value.Jobtypebox);
    this.isPostLoad=true;
    if(form.value.Jobtypebox =='Private' ){
      this.privateBox=true;
      this.techBox=false;
      this.nontechBox=false;
    }else if(form.value.Jobtypebox =='Govt/PSU Technical' ){
      this.privateBox=false;
      this.techBox=true;
      this.nontechBox=false;
    }else if(form.value.Jobtypebox =='Govt/PSU Non Technical' ){
      this.privateBox=false;
      this.techBox=false;
      this.nontechBox=true;
    }else{
      this.privateBox=true;
      this.techBox=true;
      this.nontechBox=true;
    }
    form.value.offset=0;
    form.value.limit=this.limit;
    form.value.distancestart='0';
    form.value.distance='15';
    // empty list before search
    this.privateJob =[];
    this.nontechnical = [];
    this.technical = [];
    this.getjoblist(form.value);
  }
  

getjoblist(formvalue){
 
  this.job.getjobfilterlist(formvalue).subscribe((data : any)=>{
    this.isJobLoad=false;
    if(data.error==0){
    if(data.results.length>0){
        this.datanotfound=false;
        this.isPostLoad=false;
                
    for(let key in data.results) {

        let value = data.results[key];
        if(value.jobType =='Private'){
         if(this.privateJob.length < 10){
          this.privateJob.push(value);   
         } 
         this.privateAll.push(value);
        }
        if(value.jobType =='Govt/PSU Non Technical'){
          if(this.nontechnical.length < 10){
             this.nontechnical.push(value);
          }
          this.nontechnicalAll.push(value);

        }  
        if(value.jobType =='Govt/PSU Technical'){
          if(this.technical.length < 10){
            this.technical.push(value);
          }
          this.technicalAll.push(value);
        }
    }  
       //this.getposttopic();
      }
      else{
        
        this.isPostLoad=false;
        this.noMoreResults = true;
        this.filterdetail=data.results;
        
      }
     
    }
    else{
      //this.datanotfound=true;
      this.msg=data.message;
    }

  }, (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    });    
}

gettopic(topicId){
  var encodeURI =   encodeURIComponent(btoa(topicId));
  //console.log('>>>>>>'+encodeURI);
  //return false;
   this.router.navigateByUrl('/topic/'+encodeURI);
}

/*********GEO LOCATION**********/

ngOnChanges(): any {
  this.moduleinit = true;
  this.moduleInit();
}
getTopicImage(imagename){
  return this.global.recruiterUrl+imagename;
  
}
makeurl(Id){
  let encodeUrl:any;
  encodeUrl="cid="+Id+"&lat="+this.lat+"&lng="+this.lng;
  encodeUrl=encodeURIComponent(encodeUrl);
  let url =  this.pathsocialshare+'22222222';
  console.log(url);
  return url;
}
detailpg(Id){
  let encodeUrl:any;
  encodeUrl="cid="+Id+"&lat="+this.lat+"&lng="+this.lng;
  encodeUrl=encodeURIComponent(encodeUrl);

  this.router.navigateByUrl('/jobdetail?searchparam='+btoa(encodeUrl));
}


listJob(jobtype){ 
  let encodeId:any;  
  encodeId=encodeURIComponent(jobtype);
  this.router.navigateByUrl('/jobfulllist?jobType='+btoa(encodeId));
}

listAllAnnouncement(){ 
 
  this.router.navigateByUrl('/jobannouncementlist');
}

//function called when click event happens in input box. (Binded with view)
searchinputClickCallback(event: any): any {
  
  event.target.select();
  this.searchinputCallback(event);
}
deselectlocationmap(event: any): any{  
  this.dropdownOpen = false;
}

//function called when there is a change in input. (Binded with view)
searchinputCallback(event: any): any {
  
  let inputVal: any = this.locationInput;
  if ((event.keyCode === 40) || (event.keyCode === 38) || (event.keyCode === 13)) {
    this.navigateInList(event.keyCode);
    ///console.log(this.navigateInList(event.keyCode));
  } else if (inputVal) {
    
    this.getListQuery(inputVal);
    //console.log(this.getListQuery(inputVal));
  } else {
    //console.log('tttt');
    this.queryItems = [];
    if (this.userSelectedOption) {
      this.userQuerySubmit('false');
    }
    this.userSelectedOption = '';
    if (this.settings.showRecentSearch) {
      this.showRecentSearch();
    }else {
      this.dropdownOpen = false;
    }
  }
}

//function to execute when user hover over autocomplete list.(binded with view)
activeListNode(index: number): any {
  for (let i: number = 0; i < this.queryItems.length; i++) {
    if (index === i) {
      this.queryItems[i].active = true;
      this.selectedDataIndex = index;
    }else {
      this.queryItems[i].active = false;
    }
  }
}

//function to execute when user select the autocomplete list.(binded with view)
selectedListNode(index: number): any {
  this.dropdownOpen = false;
  if (this.recentDropdownOpen) {
    this.setRecentLocation(this.queryItems[index]);
  }else {
    this.getPlaceLocationInfo(this.queryItems[index]);
  }
}

//function to close the autocomplete list when clicked outside. (binded with view)
closeAutocomplete(event: any): any {
  if (!this._elmRef.nativeElement.contains(event.target)) {
    this.selectedDataIndex = -1;
    this.dropdownOpen = false;
  }
}

//function to manually trigger the callback to parent component when clicked search button.
userQuerySubmit(selectedOption?: any): any {
  //console.log('ffff');
  let _userOption: any = selectedOption === 'false' ? '' : this.userSelectedOption;
  if (_userOption) {
    this.componentCallback.emit({'response': true, 'data': this.userSelectedOption});
  }else {
    this.componentCallback.emit({'response': false, 'reason': 'No user input'});
  }
}

//function to get user current location from the device.
currentLocationSelected(): any {  
  if (isPlatformBrowser(this.platformId)) {
    this.gettingCurrentLocationFlag = true;
    this.dropdownOpen = false;
    this._autoCompleteSearchService.getGeoCurrentLocation().then((result: any) => {
      if (!result) {
        this.gettingCurrentLocationFlag = false;
        this.componentCallback.emit({'response': false, 'reason': 'Failed to get geo location'});
      }else {
        this.getCurrentLocationInfo(result);
      }
    });
  }
}

//module initialization happens. function called by ngOninit and ngOnChange
private moduleInit(): any {
  this.settings = this.setUserSettings();
  //condition to check if Radius is set without location detail.
  if (this.settings.geoRadius) {
      if (this.settings.geoLocation.length !== 2) {
        this.isSettingsError = true;
        this.settingsErrorMsg = this.settingsErrorMsg +
        'Radius should be used with GeoLocation. Please use "geoLocation" key to set lat and lng. ';
      }
  }

  //condition to check if lat and lng is set and radious is not set then it will set to 20,000KM by default
  if ((this.settings.geoLocation.length === 2) && !this.settings.geoRadius) {
    this.settings.geoRadius = 20000000;
  }
  if (this.settings.showRecentSearch) {
    this.getRecentLocations();
  }
  if (!this.settings.useGoogleGeoApi) {
    if (!this.settings.geoPredictionServerUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Prediction custom server url is not defined. Please use "geoPredictionServerUrl" key to set. ';
    }
    if (!this.settings.geoLatLangServiceUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Latitude and longitude custom server url is not defined. Please use "geoLatLangServiceUrl" key to set. ';
    }
    if (!this.settings.geoLocDetailServerUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Location detail custom server url is not defined. Please use "geoLocDetailServerUrl" key to set. ';
    }
  }
  this.locationInput = this.settings.inputString;
}

//function to process the search query when pressed enter.
private processSearchQuery(): any {
  if (this.queryItems.length) {
    if (this.selectedDataIndex > -1) {
      this.selectedListNode(this.selectedDataIndex);
    }else {
      this.selectedListNode(0);
    }
  }
}

//function to set user settings if it is available.
private setUserSettings(): Settings {
  let _tempObj: any = {};
  if (this.userSettings && typeof(this.userSettings) === 'object') {
    let keys: string[] = Object.keys(this.defaultSettings);
    for (let value of keys) {
      _tempObj[value] = (this.userSettings[value] !== undefined) ? this.userSettings[value] : this.defaultSettings[value];
    }
    return _tempObj;
  }else {
    return this.defaultSettings;
  }
}

//function to get the autocomplete list based on user input.
private getListQuery(value: string): any {

  this.recentDropdownOpen = false;
  if (this.settings.useGoogleGeoApi) {
    let _tempParams: any = {
      'query': value,
      'countryRestriction': this.settings.geoCountryRestriction,
      'geoTypes': this.settings.geoTypes 
    };
   
    if (this.settings.geoLocation.length === 2) {
     
      _tempParams.geoLocation = this.settings.geoLocation;
      _tempParams.radius = this.settings.geoRadius;
    }
    this._autoCompleteSearchService.getGeoPrediction(_tempParams).then((result) => {
      this.updateListItem(result);
    });
  }else {
    this._autoCompleteSearchService.getPredictions(this.settings.geoPredictionServerUrl, value).then((result) => {
      result = this.extractServerList(this.settings.serverResponseListHierarchy, result);
      this.updateListItem(result);
    });
  }
}

//function to extratc custom data which is send by the server.
private extractServerList(arrayList: any, data: any): any {
  if (arrayList.length) {
    let _tempData: any = data;
    for (let key of arrayList) {
      _tempData = _tempData[key];
    }
    return _tempData;
  }else {
    return data;
  }
}

//function to update the predicted list.
private updateListItem(listData: any): any {
  this.queryItems = listData ? listData : [];
  this.dropdownOpen = true;
}

//function to show the recent search result.
private showRecentSearch(): any {
  this.recentDropdownOpen = true;
  this.dropdownOpen = true;
  this._autoCompleteSearchService.getRecentList(this.settings.recentStorageName).then((result: any) => {
    if (result) {
      this.queryItems = result;
    }else {
      this.queryItems = [];
    }
  });
}

//function to navigate through list when up and down keyboard key is pressed;
private navigateInList(keyCode: number): any {
  let arrayIndex: number = 0;
  //arrow down
  if (keyCode === 40) {
    if (this.selectedDataIndex >= 0) {
      arrayIndex = ((this.selectedDataIndex + 1) <= (this.queryItems.length - 1)) ? (this.selectedDataIndex + 1) : 0;
    }
    this.activeListNode(arrayIndex);
  }else if (keyCode === 38) {//arrow up
    if (this.selectedDataIndex >= 0) {
      arrayIndex = ((this.selectedDataIndex - 1) >= 0) ? (this.selectedDataIndex - 1) : (this.queryItems.length - 1);
    }else {
      arrayIndex = this.queryItems.length - 1;
    }
    this.activeListNode(arrayIndex);
  } else {
    this.processSearchQuery();
  }
}

//function to execute to get location detail based on latitude and longitude.
private getCurrentLocationInfo(latlng: any): any {
  
  if (this.settings.useGoogleGeoApi) {
    this._autoCompleteSearchService.getGeoLatLngDetail(latlng).then((result: any) => {
      if (result) {
       this.setRecentLocation(result);
      }
      this.gettingCurrentLocationFlag = false;
    });
  }else {
    this._autoCompleteSearchService.getLatLngDetail(this.settings.geoLatLangServiceUrl, latlng.lat, latlng.lng).then((result: any) => {
      if (result) {
        //console.log(result);
        result = this.extractServerList(this.settings.serverResponseatLangHierarchy, result);
        this.setRecentLocation(result);
      }
      this.gettingCurrentLocationFlag = false;
    });
  }
}

//function to retrive the location info based on goovle place id.
private getPlaceLocationInfo(selectedData: any): any {

  if (this.settings.useGoogleGeoApi) {
    this._autoCompleteSearchService.getGeoPlaceDetail(selectedData.place_id).then((data: any) => {
      if (data) {       
        this.setRecentLocation(data);
      }
    });
  }else {
    this._autoCompleteSearchService.getPlaceDetails(this.settings.geoLocDetailServerUrl, selectedData.place_id).then((result: any) => {
      if (result) {
        result = this.extractServerList(this.settings.serverResponseDetailHierarchy, result);
        this.setRecentLocation(result);
      }
    });
  }
}

//function to store the selected user search in the localstorage.
private setRecentLocation(data: any): any {
  
  data = JSON.parse(JSON.stringify(data));

  data.description = data.description ? data.description : data.formatted_address;
  data.active = false;
  this.selectedDataIndex = -1;
  this.locationInput = data.description;
  this.lat=data.geometry.location.lat;
  this.latitude=data.geometry.location.lat;
  this.lng=data.geometry.location.lng;
  this.longitude=data.geometry.location.lng;
  if (this.settings.showRecentSearch) {
    this._autoCompleteSearchService.addRecentList(this.settings.recentStorageName, data, this.settings.noOfRecentSearchSave);
    this.getRecentLocations();
  }
  this.userSelectedOption = data;
  //below code will execute only when user press enter or select any option selection and it emit a callback to the parent component.
  if (!this.settings.resOnSearchButtonClickOnly) {
    this.componentCallback.emit({'response': true, 'data': data});
  }
}

//function to retrive the stored recent user search from the localstorage.
private getRecentLocations(): any {
  this._autoCompleteSearchService.getRecentList(this.settings.recentStorageName).then((data: any) => {
    this.recentSearchData = (data && data.length) ? data : [];
  });
}
/***************GEO LOCATION****************/

sharesocial(sharesocial){
  sharesocial.action=true;
  this.commonService.setSocialSharingBox(sharesocial);
}

ascList(listValue,order){ 
  this.listValue = listValue;
  this.listValue.reverse();
  if(order=='newest'){
    listValue.newest=true;
    listValue.oldest=false;
  }else{
    listValue.oldest=true;
    listValue.newest=false;
  }

        }
  announceListsort(announcementSort,order){ 
    this.announcementSort = announcementSort;
    this.announcementSort.reverse();
    if(order=='newest'){
      announcementSort.newest=true;
      announcementSort.oldest=false;
    }else{
      announcementSort.oldest=true;
      announcementSort.newest=false;
    }
     
          }
        
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vjob/vjob.component.ts